import { render, staticRenderFns } from "./Hotellet.vue?vue&type=template&id=60e4f934"
import script from "./Hotellet.vue?vue&type=script&lang=js"
export * from "./Hotellet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports